import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircleIcon } from './Icon';
import './LoadFailure.scss';

// Span markup also fits inline editor nodes. All loading failures share one
// message and one action; retries replace this panel with the delayed loader.
export default function LoadFailure({ onRetry, className = '' }) {
  const { t } = useTranslation();
  return <span className={`load-failure ${className}`.trim()} data-no-swipe>
    <span className="load-failure__message" role="alert"><AlertCircleIcon size={24} />
      <span>{t('brand:loadContentError', { defaultValue: 'Could not load the content. Please try again.' })}</span>
    </span>
    <button type="button" onClick={event => { event.preventDefault(); event.stopPropagation(); onRetry(); }}>
      {t('brand:retry', { defaultValue: 'Try again' })}
    </button>
  </span>;
}
